import { Input } from 'components/Input';
import { Box } from 'ui/Box';
import { Typography } from 'ui/Typography';
import { FC } from 'react';
import { TextArea } from 'components/TextArea';
import { Select } from 'components/Select';
import { clsx } from 'clsx';

export interface InputLabelProps {
  name: string;
  label: string;
  error?: string;
  value?: string;
  placeholder: string;
  disabled?: boolean;
  selectedValue?: string;
  selectOptions?: { value: string; label: string }[];
  variant?: 'number' | 'text' | 'textarea' | 'select';
  onSelect?: (value: string | string[]) => void;
  onChange?: (data: string) => void;
}

export const InputLabel: FC<InputLabelProps> = ({
  name,
  label,
  error,
  value,
  disabled,
  placeholder,
  selectedValue,
  variant = 'text',
  selectOptions = [],
  onSelect,
  onChange,
}) => (
  <Box
    className={clsx(
      'flex w-full flex-col gap-x-6 gap-y-2 md:flex-row',
      disabled && 'min-h-10 flex-row gap-x-6'
    )}
  >
    <Typography
      variant="bodyText"
      className="min-h-6 w-full font-semibold text-black md:max-w-44"
    >
      {label}
    </Typography>
    {disabled ? (
      <Typography className="w-max max-w-[400px] break-words text-dark">
        {placeholder}
      </Typography>
    ) : variant === 'textarea' ? (
      <TextArea
        placeholder={placeholder}
        name={name}
        error={!!error}
        helperText={error}
        value={value}
        sx={{
          minHeight: 114,
        }}
        onChange={(event) => onChange && onChange(event.target.value)}
      />
    ) : variant === 'select' ? (
      <Select
        name={name}
        options={selectOptions}
        placeholder={placeholder}
        onChange={onSelect}
        value={selectedValue}
        error={error}
      />
    ) : (
      <Input
        placeholder={placeholder}
        className="w-full"
        type={variant}
        name={name}
        error={!!error}
        helperText={error}
        value={value}
        onChange={(event) => onChange && onChange(event.target.value)}
        sx={{
          '&& .MuiOutlinedInput-root': {
            minHeight: 40,
          },
        }}
      />
    )}
  </Box>
);
